/* eslint-disable solid/no-innerhtml */

import { For, Show } from 'solid-js'
import { render } from 'solid-js/web'
import {
  debounce,
  formdataToObject,
  matchesMediaQuery,
  setUrlState,
} from '../utilities'
import { AJAX_URL, LOADING_CLASS } from '../utilities/constants'

export default class {
  constructor(el, options) {
    const formEl = el.querySelector('form')
    const inputEl = formEl.querySelector('input[type="search"]')
    const selectEl = formEl.querySelector('select')

    const onloadInputs = Array.from(formEl.querySelectorAll('.js-searchUse'))

    const messageEl = el.querySelector('.js-searchMessage')
    const resetButtonEl = el.querySelector('.js-searchReset')

    const moreButtonEl = el.querySelector('.js-searchMore')

    const listEl = el.querySelector('.js-searchList')

    const DEBOUNCE_TIME = 400

    let page = parseInt(options.page) || 1
    let prevFormDataString = null
    let formDataString = null

    async function search(page) {
      try {
        const formData = new FormData(formEl)

        if (options.action) {
          formData.append('action', options.action)
        }

        if (page) {
          formData.append('page', page)
        }

        // Prevent search of same query
        formDataString = JSON.stringify(formdataToObject(formData))
        if (prevFormDataString === formDataString) {
          return false
        }

        prevFormDataString = formDataString

        let urlState = {}
        onloadInputs.forEach((el) => {
          urlState[el.name] = el?.multiple
            ? formData.getAll(el.name)
            : formData.get(el.name)
        })

        setUrlState(urlState, 'repeat')

        el.classList.add(LOADING_CLASS)

        const response = await fetch(AJAX_URL, {
          method: 'POST',
          body: formData,
          mode: 'same-origin',
          credentials: 'same-origin',
        })

        if (options.debug) {
          console.info({ response })
        }

        const json = await response.json()

        if (options.debug) {
          console.info({ json })
        }

        return json
      } catch (e) {
        console.error({ e })
      } finally {
        el.classList.remove(LOADING_CLASS)
      }
    }

    inputEl.addEventListener(
      'input',
      debounce((e) => {
        renderSearch(false, e)
      }, DEBOUNCE_TIME),
    )

    const isTouch = matchesMediaQuery('(pointer: coarse)')
    if (isTouch) {
      inputEl.addEventListener(
        'keyup',
        (e) => e.key === 'Enter' && inputEl.blur(),
      )
    }

    inputEl.addEventListener(
      'change',
      debounce((e) => {
        renderSearch(false, e)
      }, DEBOUNCE_TIME),
    )

    moreButtonEl.addEventListener('click', (e) => {
      renderSearch(true, e)
    })

    /**
     * Reset
     */

    resetButtonEl.addEventListener('click', (e) => {
      e.preventDefault()

      formEl.reset()

      inputEl.value = ''

      setUrlState({
        s: '',
      })

      renderSearch(false, e)
    })

    /**
     * Select
     */
    let wait = false
    let timer = null
    function onSelectMutation(mutationList) {
      if (wait) return

      for (const mutation of mutationList) {
        if (mutation.attributeName === 'selected') {
          wait = true

          clearTimeout(timer)

          renderSearch()

          timer = setTimeout(() => {
            wait = false

            renderSearch()
          }, DEBOUNCE_TIME)
        }
      }
    }

    const observer = new MutationObserver(onSelectMutation)
    observer.observe(selectEl, {
      attributes: true,
      childList: false,
      subtree: true,
    })

    async function renderSearch(paged = false, event) {
      if (event?.stopImmediatePropagation) {
        event.stopImmediatePropagation()
      }

      if (inputEl.value.length > 1) {
        if (paged) {
          page += 1
        } else {
          page = 1
        }

        const result = await search(page)

        if (result === false) {
          if (paged) {
            page -= 1
          } else {
            page = 1
          }

          return false
        }

        if (result?.items?.length) {
          if (!paged) {
            listEl.replaceChildren()
          }

          render(
            () => (
              <For each={result.items}>
                {(item) => (
                  <div class="Archive-item">
                    <a class="Archive-itemInner" href={item.action.url}>
                      <div class="Archive-itemContent">
                        <Show when={item.tag || item.locked || item.external}>
                          <div class="Archive-itemTags">
                            <Show when={item.tag}>
                              <span class="Tag Tag--fill">
                                <span class="Tag-content">
                                  <span class="Tag-text" innerHTML={item.tag} />
                                </span>
                              </span>
                            </Show>
                            <Show when={item.locked}>
                              <span class="Tag Tag--fill Tag--icon">
                                <span class="Tag-content">
                                  <svg
                                    class="Tag-icon"
                                    width="20"
                                    height="25"
                                    aria-hidden="true"
                                  >
                                    <use xlink:href="#symbol-lock" />
                                  </svg>
                                </span>
                              </span>
                            </Show>
                            <Show when={item.external}>
                              <span class="Tag Tag--outline">
                                <span class="Tag-content">
                                  <span class="Tag-text">Extern länk</span>
                                </span>
                              </span>
                            </Show>
                          </div>
                        </Show>
                        <h2 class="Archive-itemTitle" innerHTML={item.title} />
                        {/*item.meta ? (
                          <p class="Archive-itemMeta">
                            {item.meta.join(' / ')}
                          </p>
                        ) : (
                          ''
                        )*/}
                      </div>
                      <svg
                        class="Archive-itemSymbol"
                        width="18"
                        height="18"
                        aria-hidden="true"
                      >
                        <use xlink:href="#symbol-arrow-right" />
                      </svg>
                    </a>
                  </div>
                )}
              </For>
            ),
            listEl,
          )

          if (result.items.length && result.pages > page) {
            moreButtonEl.removeAttribute('hidden')
          } else {
            moreButtonEl.setAttribute('hidden', true)
          }
        } else {
          listEl.replaceChildren()
          moreButtonEl.setAttribute('hidden', true)
        }

        messageEl.textContent = result.message ?? ''
      } else {
        // Do nothing if input is empty
      }
    }

    formEl.addEventListener('submit', (e) => {
      e.preventDefault()

      renderSearch(false, e)

      return false
    })

    if (options.onload && inputEl?.value?.length) {
      renderSearch(false)
    }
  }
}
